import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import usePortal from 'react-useportal';
import { IObject } from 'types';
import { Coords } from 'components/fias/fias-search/types';
import { getCoords } from 'components/fias/fias-search/utils';
import { AddressItemMenu } from './components';
import {
  AddressItemWrapper,
  ChevronIcon,
  EmptyIcon,
  ItemWrapper,
  Wrapper,
} from './address-item.styled';

interface IProps {
  item: IObject;
  /** Пустой блок на месте шеврона у групп домов, чтобы бейджи были одной ширины. */
  withEmptyIcon?: boolean;
}

export const AddressItem = observer(({ item, withEmptyIcon }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [coords, setCoords] = useState<Coords | null>(null);
  const { Portal, ref, isOpen, openPortal, closePortal } = usePortal({
    onClose: () => setOpen(false),
  });
  const [wrapperWidth, setWrapperWidth] = useState<number | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (wrapperRef.current) {
      setWrapperWidth(wrapperRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (open && ref.current) {
      const coords = getCoords(ref.current);
      setCoords(coords);
    }
  }, [open, ref]);

  const handleOpenMenu = (): void => {
    if (!(item.houses && !item.title)) {
      return;
    }

    setOpen(true);
    openPortal();
  };

  return (
    <AddressItemWrapper ref={wrapperRef}>
      <Wrapper ref={ref}>
        <ItemWrapper
          isClickable={item.houses && !item.title}
          onClick={handleOpenMenu}
        >
          <div>{item.name || item.title || item.short_address}</div>
          {!!item.selectedHouses?.length && (
            <div>
              {item.selectedHouses.length}/{item.houses?.length || 0}
            </div>
          )}
          {item.name && <ChevronIcon />}
          {withEmptyIcon && item.title && <EmptyIcon />}
        </ItemWrapper>
        {isOpen && coords && (
          <Portal>
            <AddressItemMenu
              item={item}
              coords={coords}
              closePortal={closePortal}
              menuWidth={wrapperWidth}
            />
          </Portal>
        )}
      </Wrapper>
    </AddressItemWrapper>
  );
});
